import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import * as featuresService from '../services/features';
import { entitiesAdapter } from './common/adapter';

const initialState = {
  isFetching: false,
  fetchingError: null,
  featureTypes: [],
};

const sliceName = 'features';

export const fetchAllFeatures = createAsyncThunk(
  `${sliceName}/fetchAllFeatures`,
  (args, thunkAPI) => {
    return featuresService.getFeatures().catch((error) => {
      error.clientMessage = "Can't get features from server";
      return thunkAPI.rejectWithValue(error);
    });
  }
);

const features = createSlice({
  name: sliceName,
  initialState: entitiesAdapter.getInitialState(initialState),
  reducers: {},
  extraReducers: {
    [fetchAllFeatures.fulfilled]: (state, action) => {
      state.isFetching = false;
      entitiesAdapter.setAll(state, action);
    },

    [fetchAllFeatures.pending]: (state) => {
      console.log('Pending features');
      state.isFetching = true;
      state.fetchingError = null;
    },

    [fetchAllFeatures.rejected]: (state, action) => {
      state.isFetching = false;
      state.fetchingError = action.payload;
    },
  },
});

const { reducer } = features;

const featuresAdapterSelectors = entitiesAdapter.getSelectors(
  (state) => state[sliceName]
);

export const featuresSelectors = {
  ...featuresAdapterSelectors,
  isFetching: (state) => state[sliceName].isFetching,
  fetchingError: (state) => state[sliceName].fetchingError,
};

export default reducer;



// WEBPACK FOOTER //
// ./src/store/featuresSlice.js